import React from 'react';

export default function RequestDemo() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-indigo-700 mb-4">Request a Demo</h1>
      <p className="text-gray-700">
        Fill out the form to schedule a personalized walkthrough of our platform.
      </p>
    </div>
  );
}
